import {$http, Constants} from '@/store/actions/constants';

export const tasksAction = {

  Find: ({commit, state}, search) => {
    return $http.get(`${Constants.BaseURL}/tasks`, {...state.authHeader, params: search});
  },

  Complete: ({commit, state}, payload) => {
    return $http.post(`${Constants.BaseURL}/tasks/complete`, payload, state.authHeader);
  },
};